import { useCallback, useRef } from 'react';

export function useFieldLifecycle({
  flush,
  cancel,
  onBlur,
  onKeyDown,
  flushOnBlur = true,
  cancelOnEscape = false,
  submitOnEnter = false,
  blurAfterSubmit = false,
  blurAfterCancel = false,
} = {}) {
  const skipNextBlurRef = useRef(false);

  const handleBlur = useCallback((event) => {
    if (skipNextBlurRef.current) {
      skipNextBlurRef.current = false;
      if (onBlur) onBlur(event);
      return;
    }

    if (flushOnBlur) {
      flush?.();
    }
    if (onBlur) onBlur(event);
  }, [flush, flushOnBlur, onBlur]);

  const handleKeyDown = useCallback((event) => {
    if (!event.isComposing && cancelOnEscape && event.key === 'Escape') {
      event.preventDefault();
      cancel?.();
      if (blurAfterCancel) {
        skipNextBlurRef.current = true;
        event.currentTarget?.blur?.();
      }
    }

    if (
      !event.isComposing
      && submitOnEnter
      && event.key === 'Enter'
      && !event.shiftKey
      && !event.altKey
      && !event.ctrlKey
      && !event.metaKey
    ) {
      event.preventDefault();
      flush?.();
      if (blurAfterSubmit) {
        skipNextBlurRef.current = true;
        event.currentTarget?.blur?.();
      }
    }

    if (onKeyDown) onKeyDown(event);
  }, [blurAfterCancel, blurAfterSubmit, cancel, cancelOnEscape, flush, onKeyDown, submitOnEnter]);

  return {
    handleBlur,
    handleKeyDown,
  };
}
